export const environment = {
  production: false,
   apiBaseUrl: 'https://api.staging.digitalsmartplanner.nl'
};
